import { PolicyService } from 'gw-capability-policy';
import { ClaimService} from 'gw-capability-claim';
import { AccountBillingDetailsService } from 'gw-capability-billing';

let counter = 0;
let initialized = false;

const updateCounter = (pcCount, ccCount, bcCount) => {
    counter = pcCount + ccCount + bcCount;
    initialized = true;
};

const _isMobileDevice = () => {
    return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
};

const updateNewDocumentsCount = (authHeader) => {
    const pcPromise = PolicyService.getNewDocumentsCount(_isMobileDevice, true, authHeader);
    pcPromise.then((policyDocumentsCountDTO) => {
        // Filter all of the backend documents by last 3 years
        policyDocumentsCountDTO.policyTermEnvelopes.forEach((policyTerm) => {
            policyTerm.filterByLast3Years = true;
        });

        const getClaimsSearchCriteria = function () {
            return {
                claimStates: ['open', 'draft', 'closed', 'archived'],
                policies_ML: policyDocumentsCountDTO.policyTermEnvelopes
            };
        };
        
        const ccPromise = ClaimService.getNewDocumentsCount([getClaimsSearchCriteria()], authHeader);
        
        const bcPromise = AccountBillingDetailsService.getNewDocumentsCount(policyDocumentsCountDTO.policyTermEnvelopes, authHeader);
        
        Promise.all([ccPromise, bcPromise])
            .then((data) => {
                const pcCount = policyDocumentsCountDTO.newDocumentsCount;
                let ccCount = data[0];
                let bcCount = data[1];
                if (bcCount === undefined) {
                    bcCount = 0;
                }
                if (ccCount === undefined) {
                    ccCount = 0;
                }
                updateCounter(pcCount, ccCount, bcCount);
            }).catch((error) => {
                console.error(error);
                updateCounter(policyDocumentsCountDTO.newDocumentsCount,0 , 0);
            });
    });
};

const setDocumentAsViewed = (xCenter, docId, token, document, authHeader)=> {
    let promise;
    switch (xCenter) {
        case 'bc':
            promise = AccountBillingDetailsService.setDocumentAsViewed(docId, token, authHeader);
            break;
        case 'cc':
            promise = ClaimService.setDocumentAsViewed(docId, token, authHeader);
            break;
        case 'pc':
        default:
            promise = PolicyService.setDocumentAsViewed(docId, token, authHeader);
    }
    promise.then(()=> {
        updateNewDocumentsCount(authHeader);
        document.newToPortal_ML = false;
        document.newToPortal = false;
    });
};

export default {
    getCounter: () => counter,
    setDocumentAsViewed,
    init: (authHeader) => updateNewDocumentsCount(authHeader),
    isInitialized: () => initialized
}